var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',[_c('Overlay',{staticClass:"sidebar-modal",on:{"click":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"modal"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }